export enum OrderTransactionSubtype {
  SCALE_TICKET = 'scale-ticket',
  SETTLEMENT = 'settlement',
}